import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import ProtectedRoute from './routes/ProtectedRoute';
import Layout from './views/Layout/Layout'
import Login from './views/Login'
import './styles.css'
import AcceptCareTeamComponent from "./publicComponents/AcceptCareTeamComponents";

function App() {
  return (
    <Router>
      <ToastContainer autoClose={2000} />
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/acceptCareTeam" element={<AcceptCareTeamComponent />} />
        <Route
          path="/*"
          element={
            <ProtectedRoute>
              <Layout />
            </ProtectedRoute>
          }
        ></Route>
      </Routes>
    </Router>
  );
}

export default App;
